import {Component, OnInit} from "@angular/core";
import {Moment} from "moment";
import {contextPath} from "site";
import {AvdbTypeWithIssues} from "./avdb-type";
import {DeviceService} from "./device.service";

@Component({
	selector: "update-schedule",
	template: `
		<h1>Database Update Schedule</h1>

		<ng-template #loading>
			<div class="loading-indicator">Loading...</div>
		</ng-template>

		<div *ngIf="avdbTypes; else loading">
			<p>Click on each database type below to see the schedule of updates.</p>

			<section class="updateschedule" *ngFor="let avdbType of avdbTypes">
				<header class="updateschedule_header"
					[class.updateschedule_hidden]="!avdbTypeVisibility.get(avdbType.name)"
					(click)="toggleUpdateTable(avdbType.name);"
					title="Click to expand / collapse">
					<h2>
						<avdb-type-logo [avdbType]="avdbType"></avdb-type-logo>
					</h2>
					<div>
						Updates
						<ng-container *ngIf="avdbType.daysPerCycle != null; else asNeeded">
							every {{avdbType.daysPerCycle}} days
						</ng-container>
						<ng-template #asNeeded>as needed</ng-template>
					</div>
				</header>

				<table class="updateschedule_typetable" *ngIf="avdbTypeVisibility.get(avdbType.name)">
					<thead>
						<tr>
							<th>Number</th>
							<ng-container *ngIf="avdbType.daysPerCycle != null; else creationDateHeading">
								<th>Date Available</th>
								<th>Effective Dates</th>
							</ng-container>
							<ng-template #creationDateHeading>
								<th>Date Available</th>
							</ng-template>
						</tr>
					</thead>

					<tbody>
						<tr *ngFor="let issue of avdbType.upcomingIssues">
							<td>{{issue.name}} <span *ngIf="issue.versionNumber"> ({{issue.versionNumber}})</span></td>
							<td>{{formatDate(issue.availableAt)}}</td>
							<ng-container *ngIf="avdbType.daysPerCycle != null">
								<td>{{formatDate(issue.effectiveAt)}} – {{formatDate(issue.invalidAt)}}</td>
							</ng-container>
						</tr>
					</tbody>

				</table>

				<footer  class="updateschedule_footer" *ngIf="avdbTypeVisibility.get(avdbType.name)">
					Please note:
					<ng-container *ngIf="avdbType.daysPerCycle != null; else asNeededNote">

						Updates for {{avdbType.name}} databases are available every {{avdbType.daysPerCycle}} days.

						<ng-container *ngIf="avdbType.leadTime != null">
							For your convenience, they are posted on this website {{avdbType.leadTime}} days before
							their effective date.
						</ng-container>

						<ng-container *ngIf="avdbType.leadRemovalTime != null">
							Cycles are removed from this website {{avdbType.leadRemovalTime}} days before their
							expiration date to make room for new updates.
						</ng-container>

						<em>If you miss a cycle, we cannot provide a refund.</em>

					</ng-container>
					<ng-template #asNeededNote>
						{{avdbType.name}} databases are released on as "as-needed" basis, and not on a regular
						schedule. {{avdbType.name}} databases do not have effective or expiration dates.
					</ng-template>
				</footer>

			</section>

			<section class="updateschedule">
				<header class="updateschedule_header"
					[class.updateschedule_hidden]="!avdbTypeVisibility.get('Jeppesen Charts')"
					(click)="toggleUpdateTable('Jeppesen Charts');"
					title="Click to expand / collapse">
					<h2>Jeppesen Charts</h2>
					<div>
						Updates: Refer to Jeppesen's Website for Details
					</div>
				</header>
				<div class="updateschedule_typetable updateschedule_jeppesen" *ngIf="avdbTypeVisibility.get('Jeppesen Charts')">
					Links:
					<ul>
						<li>
							<a href="{{contextPath}}/redirect/jeppesen-schedule">Jeppesen Update Schedule</a>
						</li>
					</ul>
				</div>
			</section>
		</div>
	`,
})

export class UpdateScheduleComponent implements OnInit {
	avdbTypes: Array<AvdbTypeWithIssues>;
	avdbTypeVisibility: Map<string, boolean> = new Map<string, boolean>();

	contextPath = contextPath;

	constructor(private deviceService: DeviceService) {}

	ngOnInit() {
		this.deviceService.getAvdbTypesWithIssues().subscribe(avdbTypes => {
			this.avdbTypes = _.sortBy(avdbTypes, avdbType => avdbType.name)
				.filter(avdbType => !avdbType.externalProvider);

			if (this.avdbTypes && this.avdbTypes.length > 0) {
				this.avdbTypeVisibility.set(this.avdbTypes[0].name, true);
			}
		});
	}

	formatDate(date: Moment): string {
		return date.format("YYYY MMM DD");
	}

	toggleUpdateTable(avdbTypeName: string) {
		this.avdbTypeVisibility.set(avdbTypeName, !this.avdbTypeVisibility.get(avdbTypeName));
	}
}
